module.exports = __webpack_public_path__ + "3651501c074cfb2a3d825f001a84da4f.svg";